<template>
    <div>
        <v-toolbar class="main">
            <button class="nav-back" @click="goBack"><v-icon>keyboard_arrow_left</v-icon> Tillbaka</button>
        </v-toolbar>
        <center>
            <div v-if="this.$store.state.loggingIn" style="padding: 50px">
                <v-progress-circular indeterminate :size="70" :width="7" color="green"></v-progress-circular>
            </div>
        </center>
        <div v-if="!this.$store.state.loggingIn">
            <h1>Lägg till konto</h1>
            <v-text-field type="text" v-model="newName" class="input-name-code" label="Namn" autofocus></v-text-field>
            <v-text-field id="codeInput" v-model="newCode" class="input-name-code mb-4" type="number" android:inputType="number" pattern="\d*" label="Lösenord" onkeypress='return event.charCode >= 48 && event.charCode <= 57' required></v-text-field>
            <v-btn :disabled="$store.state.loggingIn" block color="primary" @click="newProfile">Lägg till</v-btn>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{
            newName: null,
            newCode: null,
            profile:{},
            resp: {},
            prom: null,
            profile:{}
        }
    },
    methods:{
        newProfile(){
            if (this.newName != null && this.newCode != null) {
                this.profile.username = this.newName.trim();
                this.profile.password = parseInt(this.newCode);
                this.$store.commit('postProfile', this.profile);
            } else {
                window.alert("Användarnamn och lösenord krävs");
            }
        },
        goBack(){
            this.$router.push('/');
        }
    },
    created: function (){
        this.$store.state.loggingIn = false;
        this.$store.state.loggingInFailed = false;
    }
}
</script>

<style>
input[type=password] {
    -webkit-text-security: disc;
}
</style>



// WEBPACK FOOTER //
// src/components/Add_Profile.vue